/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { FormControl, FormErrorMessage, FormLabel, useColorModeValue } from '@chakra-ui/react';
import Select, { Props } from 'react-select';
import { Controller } from 'react-hook-form';
import _ from 'lodash';
import { PaginationType } from '../../../../hooks/useFetch';

interface SelectInputFormProps extends Props {
  name: string | undefined | any;
  label: string | undefined;
  options: any;
  pagination?: PaginationType;
  getOptions?: (props: any) => void;
  isRequired?: boolean;
  control: any;
  errors: any;
}

export const SelectInputForm = ({
  name,
  label,
  options,
  pagination,
  getOptions,
  isRequired,
  control,
  errors,
  ...rest
}: SelectInputFormProps) => {
  // const [formattedOptions, setFormattedOptions] = useState<any>([]);
  const [filter, setFilter] = useState({
    page: 1,
    per_page: 30,
    search: '',
  });
  const pageRef = useRef(1);

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      zIndex: 9999,
      width: '100%',
      color: state.selectProps.menuColor,
    }),
    control: (styles, { isDisabled }) => {
      return {
        ...styles,
        boxShadow: '0px 2px 4px #00000050',
        opacity: isDisabled ? 0.9 : 1,
        backgroundColor: '#FAFAFA',
        height: '100%',
        border: _.get(errors, name) ? '2px solid red' : '',
        borderColor: 'inherit',
      };
    },
    option: (provided, state) => ({
      ...provided,
      borderBottom: '1px solid grey.100',
      borderRadius: '5px',
      padding: '10px 24px',
      background: state.isSelected
        ? useColorModeValue('theme.light.redInterm', 'theme.dark.redInterm')
        : useColorModeValue('theme.light.body', 'theme.dark.body'),
      color: state.isDisabled ? 'red' : 'inherit',
    }),
    singleValue: (provided, state) => {
      const color = state.isDisabled ? '#fffff' : '#fffff';
      const transition = 'opacity 300ms';

      return { ...provided, color, transition };
    },
  };

  const searchItem = inputValue => {
    setFilter(oldState => ({
      ...oldState,
      page: 1,
      search: inputValue,
    }));
  };

  const onMenuScrollToBottom = () => {
    const nextPage = pageRef.current + 1;
    if (pagination?.has_next) {
      setFilter(oldState => ({
        ...oldState,
        page: nextPage,
      }));

      pageRef.current = nextPage;
    }
  };

  const onMenuScrollToTop = () => {
    if (pagination?.has_prev) {
      let prevPage = pageRef.current - 1;
      prevPage = prevPage > 0 ? prevPage : 1;
      setFilter(oldState => ({
        ...oldState,
        page: prevPage,
      }));

      pageRef.current = prevPage;
    }
  };

  useEffect(() => {
    if (getOptions) getOptions(filter);
  }, [filter]);

  return (
    <FormControl isRequired={isRequired} isInvalid={!!_.get(errors, name)} mb={5}>
      <FormLabel fontWeight="bold" mb={1} htmlFor={name}>
        {label}
      </FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange, onBlur, ref } }) => {
          const handleChange = newValue => {
            if (rest?.isMulti) {
              onChange(newValue || []);
            } else {
              onChange(newValue);
            }
          };

          const controlledValue = rest?.isMulti ? value || [] : value || null;

          return (
            <Select
              options={options}
              ref={ref}
              value={controlledValue}
              onChange={handleChange}
              isClearable
              isSearchable
              onInputChange={getOptions ? searchItem : () => {}}
              onBlur={onBlur}
              noOptionsMessage={() => 'Nenhum resultado encontrado'}
              loadingMessage={() => 'Carregando...'}
              onMenuClose={() => {
                pageRef.current = 1;
              }}
              onMenuScrollToBottom={getOptions ? onMenuScrollToBottom : () => {}}
              onMenuScrollToTop={getOptions ? onMenuScrollToTop : () => {}}
              styles={customStyles}
              {...rest}
            />
          );
        }}
      />
      {_.get(errors, name) && <FormErrorMessage>{_.get(errors, name)?.message}</FormErrorMessage>}
    </FormControl>
  );
};
